import { Drawer } from "antd";
import styled from "styled-components";

export const StyledDrawer = styled(Drawer)<{ $withoutBorder: boolean }>`
    ${({ $withoutBorder }) =>
        $withoutBorder &&
        `
            .ant-drawer-body {
                .ant-collapse {
                    border: none;
                }
            }
        `}
`;
